<template>
  <div id="index">
    <mHeader ref="mHeader"></mHeader>
    <div style="width:100%;height:44px"></div>
    <!-- 推荐产品 -->
    <div class="index5 productList">
      <div class="index5Box productListBox">
        <ul class="index4RightZX">
            <li v-for="item in newsList" :key="item.id" @click="toNewsDetails(item.id)"><span>•</span>{{item.articleTitle}}<b>{{item.createTime}}</b></li>
          </ul>
      </div>
      <div class="pageBox">
        <el-pagination background layout="prev, pager, next" :currentPage="currentPage" :pageSize ="pageSize" :total="totalNum"  @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
      </div>
    </div>
    <ul class="mfoot">
      <li>皖公网安备 34160202000600号   皖ICP备18026442号</li>
      <li>电话：0558-5858131</li>
      <li>地址：亳州市谯城区亳芜现代产业园区希夷大道与月季路交叉口</li>
      <li>安徽广盛堂中药饮片有限公司</li>
    </ul>
  </div>
</template>
<script>
import mHeader from '../../components/mobile/mHeader'
export default {
  components: {
     mHeader
  },
  data() {
    return {
      showLogin:true,
      productDetailsImg:require('../../assets/img/productDetailsIconImg.png'),
      productImgList:[
        {id:"001",imgUrl:require('../../assets/img/productDetailsImg1.png')},
        {id:"002",imgUrl:require('../../assets/img/productDetailsImg2.png')},
        {id:"003",imgUrl:require('../../assets/img/productDetailsImg3.png')},
        {id:"003",imgUrl:require('../../assets/img/productDetailsImg4.png')},
        {id:"003",imgUrl:require('../../assets/img/productDetailsImg5.png')}
      ],
      newsList:[],
      currentPage: 1,//默认显示第一页
      pageSize:10,//默认每页显示10条
      totalNum: 100, //总页数
    }
  },
  mounted() {
    if(this.$cookie.get('account') == null){
      this.showLogin = true
    }else{
      this.showLogin = false
    }
    this.getNewsList();
  },
  methods: {
    getNewsList() {
      this.$fetch('getArticleList',{articleType: "2",pageNo:this.currentPage,pageSize:this.pageSize}).then(res => {
       this.newsList = res.result.records;
       this.totalNum = res.result.total;
      })
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageSize = val;    //动态改变
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.getNewsList();
    },
    //跳转新闻详情
    toNewsDetails(id){
      this.$router.push({name:'mNewsDetails',query: {id:id}})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/mobile/mNewsList.vue